import {TOGGLE_DISCOVER_VITRINE_BOX, TOGGLE_DISCOVER_BDR_BOX} from './constant';

export function toggleDiscoverVitrineBox(organisationId) {
  return {
    type: TOGGLE_DISCOVER_VITRINE_BOX,
    payload: {organisationId}
  };
}

export function toggleDiscoverBdrBox(organisationId) {
  return {
    type: TOGGLE_DISCOVER_BDR_BOX,
    payload: {organisationId}
  };
}
